/**
 * Created by razial on 18.09.2026.
 */

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    PASS_TICKET_TEXT: {
        size: 40,
        color: cleverapps.styles.COLORS.COLOR_WINDOW_TEXT
    },

    PASS_PROGRESS_TEXT: {
        size: 50,
        color: cleverapps.styles.COLORS.WHITE,
        shadow: cleverapps.styles.DECORATORS.WHITE_TEXT_SHADOW
    }
});

cleverapps.overrideStyles(cleverapps.styles.PassBuyTicketWindow, {
    margin: 30,

    rewards: {
        icon: {
            dy: 13
        }
    },

    badge: {
        x: { align: "left", dx: -46 },
        y: { align: "top", dy: 6 }
    }
});

cleverapps.overrideStyles(cleverapps.styles.PassRewardIcon, {
    icon: {
        x: { align: "center", dx: 0 },
        y: { align: "center", dy: -20 }
    },

    claimButton: {
        height: 70,
        y: { align: "bottom", dy: -85 }
    },

    text: {
        x: { align: "right", dx: 6 },
        y: { align: "bottom", dy: -17 }
    },

    attention: {
        x: { align: "center", dx: 0 },
        y: { align: "bottom", dy: -80 }
    }
});

cleverapps.overrideStyles(cleverapps.styles.PassHeader, {
    decor: {
        x: { align: "center", dx: -650 },
        y: { align: "center", dy: 42 }
    },

    timer: {
        margin: 40,
        x: { align: "center" },
        y: { align: "center", dy: 30 }
    },

    amount: {
        x: { align: "center", dx: 0 },
        y: { align: "center", dy: -50 }
    },

    pack: {
        x: { align: "right", dx: -115 },
        y: { align: "center", dy: 40 }
    }
});

cleverapps.overrideStyles(cleverapps.styles.PassTicket, {
    height: 280,
    text: {
        width: 250,
        height: 70
    },
    icon: {
        height: 270
    },

    free: {
        text: 235,
        x: { align: "center", dx: 0 },
        y: { align: "center", dy: 12 },
        icon: {
            x: { align: "center", dx: 0 },
            y: { align: "center", dy: 0 }
        }
    },

    premium: {
        x: { align: "center", dx: 0 },
        y: { align: "bottom", dy: 18 },
        icon: {
            x: { align: "center", dx: 0 },
            y: { align: "center", dy: 10 }
        },
        margin: -5
    },

    button: {
        height: 70
    }
});

cleverapps.overrideStyles(cleverapps.styles.PassProgress, {
    paddingX: 125,
    tasks: {
        taskPoint: {
            numberDy: 2,
            completedNumberDy: 5
        },

        premiumReward: {
            y: { align: "center", dy: 216 }
        },

        reward: {
            y: { align: "center", dy: -107 }
        }
    }
});

cleverapps.overrideStyles(cleverapps.styles.PassTickets, {
    free: {
        x: { align: "center", dx: -8 },
        y: { align: "center", dy: -160 }
    },

    premium: {
        x: { align: "center", dx: -5 },
        y: { align: "center", dy: 150 }
    }
});

cleverapps.overrideStyles(cleverapps.styles.PassLastChanceWindow, {
    rewards: {
        ribbon: {
            x: { align: "left", dx: -12 },
            y: { align: "top", dy: -12 }
        },

        text: {
            x: { align: "center", dx: -10 },
            y: { align: "center", dy: 18 },
            width: 300,
            height: 80,
            rotation: 0
        }
    }
});
